import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { DropdownCellLayout } from './CellComponents'

interface SelectCellRendererParams {
  customRenderer?: (value: any) => React.ReactNode
}

export const SelectCellRenderer: React.FC<ICellRendererParams> = ({ value, valueFormatted, colDef }) => {
  const params = (colDef?.cellRendererParams || {}) as SelectCellRendererParams
  const { customRenderer } = params

  const displayContent = customRenderer ? customRenderer(value) : <span>{valueFormatted ?? value ?? ''}</span>

  return <DropdownCellLayout>{displayContent}</DropdownCellLayout>
}
